<template>
  <div>
    <table class="table">
      <tr
        v-for="answer in answers"
        :key="answer.id"
      >
        <td>
          <v-item-data-raw-answer
            :answer="answer"
            :renderType="renderType"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { stringToPrettyDateTime } from '@/common/utils/formatting';
import ItemDataRawAnswer from '@/organisation/components/research/widgets/ItemDataRawAnswer.vue';

export default {
  name: 'RawDataView',
  components: {
    'v-item-data-raw-answer': ItemDataRawAnswer,
  },
  data() {
    return {
      showOriginal: false,
    };
  },
  props: {
    answers: {
      type: Array,
      required: true,
    },
    renderType: {
      type: String,
      required: true,
    },
  },
  methods: {
    stringToPrettyDateTime,
  },
};
</script>


<style scoped>
.progress {
  width: 100px;
}
</style>
